import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const collapseDefaultVariants = {}
const collapseCompoundVariants = []

const collapseSlotNames = [
  [
    "root",
    "Collapse__root"
  ],
  [
    "icon",
    "Collapse__icon"
  ],
  [
    "title",
    "Collapse__title"
  ],
  [
    "wrapper",
    "Collapse__wrapper"
  ],
  [
    "inner",
    "Collapse__inner"
  ],
  [
    "content",
    "Collapse__content"
  ],
  [
    "trigger",
    "Collapse__trigger"
  ]
]
const collapseSlotFns = /* @__PURE__ */ collapseSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, collapseDefaultVariants, getSlotCompoundVariant(collapseCompoundVariants, slotName))])

const collapseFn = memo((props = {}) => {
  return Object.fromEntries(collapseSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const collapseVariantKeys = [
  "hasTitleHover"
]
const getVariantProps = (variants) => ({ ...collapseDefaultVariants, ...compact(variants) })

export const collapse = /* @__PURE__ */ Object.assign(collapseFn, {
  __recipe__: false,
  __name__: 'collapse',
  raw: (props) => props,
  variantKeys: collapseVariantKeys,
  variantMap: {
  "hasTitleHover": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, collapseVariantKeys)
  },
  getVariantProps
})